import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/PendingPaymentRequests';

const PendingPaymentRequests = () => ((orgContainer(InnerComponent)));

export default PendingPaymentRequests;
